/* eslint-disable */
// The purpose of this model is produce a valid geoJSON FeatureCollection object
import Feature from './featureModel';
import DataModel from './dataModel';

export default class Region {
    constructor(featureCollection, data) {
        this.type = 'FeatureCollection';
        this.features = [];
        this.featureCollection = featureCollection;
        this.valueKeys = this.getAllPossibleDataKeys(data);
        this.setData(data);
        DataModel.onDataUpdate(this.setData.bind(this));
    }

    setData(data) {
        // @TODO update, rather than destroy + re-create entire model
        this.features = [];
        const dataFeatures = data || {};
        const sourceFeatures = this.featureCollection.features || {};
        // @TODO consider calling this.getAllPossibleDataKeys() instead of relying on the value cached in this.valueKeys - slow but will always catch data structure changes
        const valueKeys = this.valueKeys || ['default'];

        const sourceFeaturesLength = sourceFeatures.length;
        for (let i = 0; i < sourceFeaturesLength; i++) {
            const sourceFeature = sourceFeatures[i];
            const id = sourceFeature.properties.id ? String(sourceFeature.properties.id) : null;
            const geometryData = sourceFeature.geometry || null;
            let propertiesData;
            if (geometryData) {
                // @TODO add debug option - for now disable this logging as it is surprisingly slow!
                //if (id === null) {
                //    //console.log('The following feature does not contain an id, and will not contain any data:', sourceFeature);
                //}
                //else {
                    propertiesData = dataFeatures[id] || {};
                    Object.assign(propertiesData, sourceFeature.properties);
                //}

                this.addFeature(id, geometryData, propertiesData, valueKeys);
            }
        }
    }

    addFeature(id, geometryData, propertiesData, valueKeys) {
        const feature = new Feature(id, geometryData, propertiesData, valueKeys);
        let found = false;

        for (let i = 0; i < this.features.length; i++) {
            if (this.features[i].id === geometryData.id) {
                console.log('The following features have colliding IDs:', this.features[i], feature);
                this.features.splice(i, 1, feature);
                found = true;
                break;
            }
        }
        if (!found) {
            this.features.push(feature);
        }
    }

    getFeatureById(id) {
        const searchId = String(id).toLowerCase();
        let requestedFeature;

        if (id) {
            requestedFeature = this.features.find((feature) => feature.id === searchId);
        }

        return requestedFeature;
    }

    removeFeatureById(id, model) {
        const featureToRemove = this.getFeatureById(id);
        const idOfFeatureToRemove = String(featureToRemove.id).toUpperCase();
        let indexToRemove;

        for (let i = 0; i < model.features.length; i++) {
            if (model.features[i].properties.id === idOfFeatureToRemove) {
                indexToRemove = i;
                break;
            }
        }
        if (indexToRemove) {
            model.features.splice(indexToRemove, 1);
        }

        return model;
    }

    getValueExtremes(valueKey) {
        let min = null;
        let max = null;

        for (let i = 0; i < this.features.length; i++) {
            const feature = this.features[i];
            const value = feature.properties.values[valueKey];
            if (value) {
                if (min === null && max === null) {
                    min = value;
                    max = value;
                }
                if (value < min) {
                    min = value;
                }
                if (value > max) {
                    max = value;
                }
            }
        }

        return [min, max];
    }

    getAllPossibleDataKeys(data) {
        let dataKeys = new Set();
        const gssids = Object.keys(data);
        const gssidsLength = gssids.length;
        for (let i = 0; i < gssidsLength; i++) {
            const gssid = gssids[i];
            const properties = Object.keys(data[gssid]);
            const propertiesLength = properties.length;
            for (let j = 0; j < propertiesLength; j++) {
                dataKeys.add(properties[j]);
            }
        }
        return Array.from(dataKeys); // returns unique keys
    }
}
